import {Machine, assign} from 'xstate';


const BuildPalletMachine = Machine({
        id: "buildPallet",
        context: {
            events: [],
            pallet: null,
            startPalletData: {},
            finishPalletData: {}
        },
        initial: "init",
        ERROR: {
            target: "error",
            actions: ["logError"]
        },
        states: {
            init: {
                invoke: {
                    src: 'getCurrentAndLastPallet',
                    onDone: [
                        {
                            target: 'buildingPallet',
                            actions: assign({pallet: (context, event) => event.data.pallet, lastPallet: (context, event) => event.data.lastPallet }),
                            cond: (_ctx, event) => { // Current pallet, then we can go to building pallet
                                const current = event.data.pallet;
                                if (current) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        },
                        { // otherwise goto no pallet building
                            target: 'noPalletBuilding',
                            actions: assign({pallet: (context, event) => event.data.pallet})
                        }]
                    ,
                    onError: {
                        target: 'error',
                        actions: assign({error: (context, event) => event})
                    }

                }
            },
            error: {
                on: {
                    STARTOVER: {
                        target: "init"
                    }
                },
                entry: ['logError'],
            },
            noPalletBuilding: {
                on: {
                    PALLETSTARTED: {
                        target: "startingPallet",
                        actions: assign({startPalletData: (context, event) => event})
                    }
                }
            },
            startingPallet: {
                invoke: {
                    src: 'startPallet',
                    onDone: {
                        target: 'buildingPallet',
                        actions: assign({pallet: (context, event) => event.data.pallet, lastPallet: (context, event) => event.data.lastPallet }),
                    },
                    onError: {
                        target: 'error',
                        actions: assign({error: (context, event) => event})
                    }
                }
            },
            buildingPallet: {
                on: {
                    ENDPALLET: {
                        target: "finishPallet"
                    },
                    CANCEL: {
                        target: "cancelling"
                    },
                    REFRESH: {
                        target: "buildingPallet",
                        actions: ["refreshPallet"]
                    }
                }
            },
            finishPallet: {
                on: {
                    PRINTNOW: {
                        target: "finishingPalletPrintNow",
                        actions: assign({finishPalletData: (context, event) => event})
                    },
                    PRINTLATER: {
                        target: "finishingPalletPrintLater",
                        actions: assign({finishPalletData: (context, event) => event})
                    },
                    CANCEL: {
                        target: "buildingPallet"
                    }
                }
            },
            cancelling: {
                invoke: {
                    src: 'cancelCurrentPallet',
                    onDone: {
                        target: 'init',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({error: (context, event) => event.data})
                    }
                }
            },
            finishingPalletPrintNow: {
                invoke: {
                    src: 'finishPallet',
                    onDone: {
                        target: 'printingManifest',
                        actions: assign({pallet: (context, event) => event.data})
                    },
                    onError: {
                        target: 'error',
                        actions: assign({error: (context, event) => event})
                    }
                }
            },
            finishingPalletPrintLater: {
                invoke: {
                    src: 'finishPallet',
                    onDone: {
                        target: 'init',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({error: (context, event) => event})
                    }
                }
            },
            printingManifest: {
                invoke: {
                    src: 'printManifest',
                    onDone: {
                        target: 'finished',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({
                            error: (context, event) => {
                                return {errorEventData: event.data}
                            }
                        })
                    }
                }
            },
            finished: {
                after: {
                    3000: 'init'
                }

            },
            loaded: {},
            failure: {}
        },
    },
);

export default BuildPalletMachine;

